import '@css/App.scss';
import ErrorPage from '@routes/error-page';
import Root from '@routes/root';
import { namespace } from '@utils/common';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import NcvMain from './pages/NcvMain';

const App = () => {
    const container = document.querySelector('.app-container');
    if (!container) throw new Error('no ranking container');

    const router = createBrowserRouter([
        {
            path: '/',
            element: <Root />,
            errorElement: <ErrorPage />,
            children: [
                {
                    path: '/',
                    element: <NcvMain />,
                },
            ],
        },
    ]);

    createRoot(container).render(
        <RouterProvider router={router} />
    );
};

namespace('nc.nvg');
window.nc.nvg.home = App;
